import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=2cb7dc38&scoped=true&"
import script from "./Header2.vue?vue&type=script&lang=js&"
export * from "./Header2.vue?vue&type=script&lang=js&"
import style0 from "./Header2.vue?vue&type=style&index=0&id=2cb7dc38&prod&lang=scss&scoped=true&"
import style1 from "./Header2.vue?vue&type=style&index=1&id=2cb7dc38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7dc38",
  null
  
)

export default component.exports